document.addEventListener('DOMContentLoaded', function() {
  
  // Listen for product added to cart
  const cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    //// console.log('Product added to cart:', event);
    //// console.log('Source:', event.source); // will be "product-form" when added
    //// console.log('Product Variant ID:', event.productVariantId);
    
    // Your custom logic here
    if (event.source === "product-form") {
      // Handle product added to cart
      handleProductAddedToCart(event.productVariantId);
    }
  });

  // Listen for cart errors (failed add to cart)
  const cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
    //// console.log('Cart error:', event);
    //// console.log('Error message:', event.message);
    //// console.log('Error details:', event.errors);
    
    // Your custom error handling here
    handleCartError(event);
  });

  // Listen for product removed from cart
  // Note: The cart.js file publishes cartUpdate events when items are removed too
  const cartRemoveUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source === "cart-items") {
    ////   console.log('Cart updated (could be remove/quantity change):', event);
      // You'll need additional logic to determine if it's a removal
      handleCartItemsUpdate(event);
    }
  });

  // Clean up subscriptions when needed (optional)
  // cartUpdateUnsubscriber();
  // cartErrorUnsubscriber();
  // cartRemoveUnsubscriber();
});

function handleProductAddedToCart(variantId) {
   //console.log(`Product variant ${variantId} was added to cart`);
  
  if (variantId == '47799045095653') {
    // Get the cart drawer to access getSectionsToRender
    const cartDrawer = document.querySelector("cart-drawer");
    
    // Build the proper request with sections
    const formData = new FormData();
    formData.append('id', '48181968830693'); // was 47902267769061
    formData.append('quantity', '1');
    
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map(section => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          console.error('Error adding bonus product:', response.description);
        } else {
           //console.log('Successfully added bonus product');
          
          // Now we have the proper response with sections
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
          }
        }
      })
      .catch(error => {
        console.error('Error adding bonus product:', error);
      });
  }
}

function handleCartError(errorEvent) {
  // Your custom error handling
   //console.log('Failed to add product to cart:', errorEvent.message);
}

function handleCartItemsUpdate(event) {
////   console.log('Cart items were updated');
  
  // Get current cart to check what's in it
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const targetVariantId = '47799045095653'; // Main product
      const bonusVariantId = '48181968830693';  // Bonus product
      
      // Check if either product is in the cart
      const hasTargetProduct = cart.items.some(item => item.variant_id == targetVariantId);
      const hasBonusProduct = cart.items.some(item => item.variant_id == bonusVariantId);
      
       //console.log('Has target product:', hasTargetProduct);
       //console.log('Has bonus product:', hasBonusProduct);
      
      // If target product is removed but bonus is still there, remove bonus
      if (!hasTargetProduct && hasBonusProduct) {
         //console.log('Target product removed, removing bonus product');
        removeProductFromCart(bonusVariantId);
      }
      
      // If bonus product is removed but target is still there, remove target
      if (!hasBonusProduct && hasTargetProduct) {
         //console.log('Bonus product removed, removing target product');
        removeProductFromCart(targetVariantId);
      }
    })
    .catch(error => {
      console.error('Error checking cart contents:', error);
    });
}

function removeProductFromCart(variantId) {
  // First get current cart to find the line item key
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Find the line item for this variant
      const lineItem = cart.items.find(item => item.variant_id == variantId);
      
      if (lineItem) {
        // Remove the product by setting quantity to 0
        const formData = new FormData();
        formData.append('id', lineItem.key);
        formData.append('quantity', '0');
        
        // Add cart sections for UI updates
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cartDrawer.getSectionsToRender().map(section => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        fetch(window.routes.cart_change_url, config)
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              console.error('Error removing product:', response.description);
            } else {
               //console.log(`Successfully removed product ${variantId}`);
              
              // Update cart UI
              if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(response);
              }
            }
          })
          .catch(error => {
            console.error('Error removing product:', error);
          });
      } else {
         //console.log(`Product ${variantId} not found in cart`);
      }
    })
    .catch(error => {
      console.error('Error fetching cart for removal:', error);
    });
}